import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Modal from '@material-ui/core/Modal';
import Parser from 'rss-parser';
import Header from '../../components/Header';
import MenuBox from '../../components/MenuBox';
import { isAuthenticated } from '../../auth/Auth';
import DetailPostModal from '../../components/molecules/DetailPostModal';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      margin: '0 auto'
    }
  },
  mainContent: {
    padding: 15
  },
  listNotis: {
    padding: 0
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  itemNoti: {
    padding: 10,
    borderBottom: '1px solid #DBDBDB',
    cursor: 'pointer'
  },
  titlePage: {
    fontSize: 24,
    fontWeight: 'bold',
    padding: '15px 15px 0'
  },
  dateText: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 5
  },
  titleContent: {
    fontSize: 14
  },
  supportTimeTxt: {
    fontSize: 14,
    marginTop: 15
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('rssItems', 'setRssItems', []),
  withState('openDetailPost', 'setDetailPost', false),
  withState('content', 'setContent', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      const parser = new Parser();
      parser.parseURL(
        `https://shops.gochimeshi.com/feeds/42755547-51ae-4b47-af16-f50b58d106f2.rss`,
        (err, feed) => {
          if (err) throw err;
          this.props.setRssItems(feed.items);
        }
      );
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    name,
    handleRedirect,
    rssItems,
    openDetailPost,
    setDetailPost,
    content,
    setContent
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    // check if is account shop
    if (!(isShop && isReleased)) {
      handleRedirect('/shops');
    }

    console.log(rssItems);

    const actionOpenDetail = params => {
      setContent(params);
      setDetailPost(true);
    };

    const dateFormat = timeStr => {
      if (!timeStr) {
        return null;
      }
      const date = new Date(timeStr);
      const day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = date.getFullYear();
      return `${year}/${month}/${day}`;
    };
    return (
      <div className={classes.root}>
        <Header name={name} />
        <Typography variant="h5" className={classes.titlePage}>
          運営からのお知らせ
        </Typography>

        <div className={classes.mainContent}>
          {rssItems && (
            <Paper className={classes.mainPaper} elevation={1}>
              <List
                component="nav"
                className={classes.listNotis}
                aria-label="contacts"
              >
                {rssItems.map((item, index) => {
                  const params = {
                    title: item.title,
                    content: item.content,
                    pubDate: dateFormat(item.pubDate)
                  };
                  return (
                    <>
                      <ListItem
                        className={classes.itemNoti}
                        onClick={() => actionOpenDetail(params)}
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                      >
                        <div>
                          <div className={classes.dateText}>
                            {dateFormat(item.pubDate)}
                          </div>
                          <div className={classes.titleContent}>
                            {item.title}
                          </div>
                        </div>
                      </ListItem>
                    </>
                  );
                })}
              </List>
            </Paper>
          )}
        </div>
        <MenuBox account={account} />
        <Modal
          open={openDetailPost}
          onClose={() => {
            setDetailPost(false);
          }}
          className={classes.modalMobile}
        >
          <DetailPostModal
            setDetailPost={setDetailPost}
            params={content}
            // textTitle={textTitle}
            // textMessage={textMessage}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
